import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LocalizationService } from 'app/shared/localization/localization.service';

@Component({
  selector: 'app-upload-image',
  templateUrl: './upload-image.component.html',
  styleUrls: ['./upload-image.component.scss']
})
export class UploadImageComponent implements OnInit {
  _imageUrl: string;
  @Output() imageUrlChange = new EventEmitter();
  @Output() deleteEvent = new EventEmitter<void>(); 
  @Input() get imageUrl(): string { return this._imageUrl; }
  set imageUrl(val: string) {
    this._imageUrl = val;
  }

  @Input() maxFileSize = 512000;//50kb
  url: any;
  msg = "";

  constructor(private _localizationService: LocalizationService) {

  }
  ngOnInit() { }

  selectFile(event: any) {
    const selectedFile = event.target.files[0] as File;
    if (!selectedFile && !this.imageUrl) {
      this.msg = this._localizationService.Translate('ERRORS.CHOOSE_IMAGE');
      return;
    } else if (!selectedFile.type.match(/image\/*/)) {
      this.msg = this._localizationService.Translate('ERRORS.ONLY_IMAGE_SUPPORTED');
      return;
    } else if (selectedFile.size > this.maxFileSize) {
      this.msg = this._localizationService.Translate('ERRORS.MAX_FILE_SIZE', { size: this.maxFileSize / 1024 });
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(selectedFile);

    reader.onload = (_event) => {
      this.msg = "";
      this.imageUrl = reader.result.toString();
      this.imageUrlChange.emit(this._imageUrl);
    }
  }
  triggerFileInputClick(fileInput: HTMLInputElement) {
    fileInput.click();
  }
  deleteImage() {
    this.imageUrl = null;
    this.imageUrlChange.emit(null);
    this.deleteEvent.emit(); 
    const fileInput = document.getElementById('file-input') as HTMLInputElement;
  if (fileInput) {
    fileInput.value = '';
  }

  }

}

